<template>
  <div class="container_four">
    <div class="chain">
      <div class="header">
        <div class="title">
          <div class="title">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                能耗环比·{{ downval.label
                }}<img src="../../assets/img/ardown.png" alt="" />
              </span>
              <el-dropdown-menu slot="dropdown" style="width:6vw">
                <el-dropdown-item v-for="item in downlist" :command="item">{{
                  item.label
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="tabs-container">
          <span
            :class="timeval.label == item.label ? 'active' : ''"
            @click="(timeval = item), (isChain = index)"
            v-for="(item, index) in timelist"
            >{{ item.label }}</span
          >
        </div>
      </div>
      <div class="cont">
        <div class="charts" v-loading="loadingchain">
          <charts id="ratio" :option="ratioOption"></charts>
        </div>
        <div class="used">
          <div class="line" v-for="(item, index) in ring" :key="index">
            <div class="totol">
              <i v-for="(elm, index2) in item.class" :key="index2">{{
                elm.name
              }}</i>
            </div>
            <div class="parameter">
              <span>{{ item.data }}</span>
              <label
                >{{ item.keep }}
                <img :src="item.imgred" v-if="item.isgrow > 0" />
                <img :src="item.imggen" v-else-if="item.isgrow == 0" />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chain">
      <div class="header">
        <div class="title">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              能耗同比·{{ downval.label
              }}<img src="../../assets/img/ardown.png" alt="" />
            </span>
            <el-dropdown-menu slot="dropdown" style="width:6vw">
              <el-dropdown-item v-for="item in downlist" :command="item">{{
                item.label
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="cont">
        <div class="charts" v-loading="loading">
          <charts id="Chain" :option="chainOption"></charts>
        </div>
        <div class="used">
          <div class="line" v-for="(item, index) in same" :key="index">
            <div class="totol">
              <i v-for="(elm, index2) in item.class" :key="index2">{{
                elm.name
              }}</i>
            </div>
            <div class="parameter">
              <span>{{ item.data }}</span>
              <label
                >{{ item.keep }}
                <img :src="item.imgred" v-if="item.isgrow > 0" />
                <img :src="item.imggen" v-else-if="item.isgrow == 0" />
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="cont" v-else style="text-align: center;">
        <img
            class="nodata"
            src="../../assets/img/not_found_data.png"
            alt=""
            height="80%"
          />
      </div> -->
    </div>
  </div>
</template>

<script>
import charts from "./charts.vue";
import {
  dateFormat,
  dayEnd,
  dayStart,
  nextDay,
  nextMonth,
  nextYear,
  perDay,
  perMonth,
  perYear,
} from "../../util/DateUtil";
import { chainIndex } from "../../api/linkindex";
import {
  ProjectCompareClassifiedPower,
  PowerMonthOnMonth,
} from "../../api/power";
export default {
  components: {
    charts,
  },
  data() {
    return {
      isChain: 2,
      isActive: 0,
      same: [],
      ring: [],
      chartRatioOption: [],
      chartChainOption: [],
      downval: {
        value: "electricity",
        unit:"kWh",
        label: "电",
      },
      timeval: {
        label: "月",
        value: "MONTH",
      },
      timelist: [
        {
          label: "日",
          value: "DAY",
        },
        {
          label: "周",
          value: "WEEK",
        },
        {
          label: "月",
          value: "MONTH",
        },
        {
          label: "年",
          value: "YEAR",
        },
      ],
      downlist: [
         {
          value: "electricity",
          unit:"kWh",
          label: "电",
        },
        {
          value: "water",
          unit:"m³",
          label: "水",
        },
        {
          value: "heat",
          unit:"GJ",
          label: "热",
        },
        {
          value: "cooling",
          unit:"GJ",
          label: "冷",
        },
      ],
      loading: false,
      loadingchain: false,
      chartShow:true
    };
  },
  mounted() {},
  computed: {
    propsData() {
      return [this.downval, this.timeval];
    },
    ratioOption() {
      let title = ["本月                                  上月"];
      if (this.isChain == 0) {
        title = ["本日                                  昨日"];
      } else if (this.isChain == 1) {
        title = ["本周                                  上周"];
      } else if (this.isChain == 2) {
        title = ["本月                                  上月"];
      } else {
        title = ["本年                                  去年"];
      }
      return {
        title: {
          subtext: "用"+this.downval.label+"量（"+this.downval.unit+"）",
          top: "-5%",
        },
        tooltip: {
          position: function(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{a} {c} ("+this.downval.unit+")", // 这里是鼠标移上去的显示数据
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
        },

        //ech图形pading
        grid: {
          left: "2%",
          right: "0%",
          bottom: "15%",
          top: "20%",
          containLabel: true,
        },

        legend: {
          itemWidth: 12,
          itemHeight: 12,
          x: "center",
          // data: ["本月", "上月"],
          left: "right", // 图例的位置
          textStyle: {
            color: "#999999",
          },
        },
        calculable: true,
        xAxis: [
          {
            show: true,
            name: title,
            nameLocation: "middle",
            type: "category",
          },
        ],
        // 边界值
        yAxis: [
          {
            type: "value",
            scale: true,
            min: 0,
            splitNumber: 5,
            type: "value",
          },
        ],
        series: this.chartRatioOption,
      };
    },
    chainOption() {
      let xdata = [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ];
      return {
        title: {
          subtext: "用"+this.downval.label+"量（"+this.downval.unit+"）",
          top: "-5%",
        },
        tooltip: {
          position: function(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{a} {c} ("+this.downval.unit+")", // 这里是鼠标移上去的显示数据
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
        },
        grid: {
          left: "2%",
          right: "0%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },

        legend: {
          itemWidth: 12,
          itemHeight: 12,
          x: "center",
          // data: ["本月", "上月"],
          left: "right", // 图例的位置
          textStyle: {
            color: "#999999",
          },
        },
        calculable: true,
        xAxis: {
          type: "category",
          data: xdata,
        },
        // 边界值
        yAxis: [
          {
            type: "value",
          },
        ],
        series: this.chartChainOption,
      };
    },
  },
  watch: {
    timeval() {
      this.chainData();
    },
    downval() {
      this.chainData();
      this.sameData();
    },
  },
  mounted() {
    //SEPARATED 同比  //ALTERNATE  环比
    this.chainData();
    this.sameData();
  },
  methods: {
    handleCommand(command) {
      this.downval = command;
    },
    async sameData() {
      this.loading = true;
      this.chartShow = true
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        date: dateFormat("YY-mm-dd", new Date()) + "T00:00:00Z",
        powerType: this.downval.value.toUpperCase(),
      };
      let response = await PowerMonthOnMonth(obj);
      let num = 0,
        num2 = 0;
        if(response.data.data.data==undefined){
          this.loading = false
          this.chartShow = false
          return false
        }
      response.data.data.data.map((e) => (num += Number(e[0])));
      response.data.data.data.map((e) => (num2 += Number(e[1])));
      let data = [num.toFixed(2), num2.toFixed(2)];
      let data1 = response.data.data.data.map((e) => e[0].toFixed(2));
      let data2 = response.data.data.data.map((e) => e[1].toFixed(2));
      this.chartChainOption = [
        {
          name: "本期",
          data: data2,
          type: "bar",
          barWidth: 15,
          itemStyle: {
            color: "#5AD8A6",
          },
        },
        {
          name: "上期",
          data: data1,
          type: "bar",
          barWidth: 15,
          itemStyle: {
            color: "#5B8FF9",
          },
        },
      ];
      if (data) {
        this.$set(this.same, 0, {
          id: 1,
          class: [
            {
              id: 1,
              name: "本",
            },
            {
              id: 2,
              name: "期",
            },
            {
              id: 3,
              name: "用",
            },
            {
              id: 4,
              name: this.downval.label,
            },
          ],
          data: data[1],
          keep: this.downval.unit,
        });
        this.$set(this.same, 1, {
          id: 2,
          class: [
            {
              id: 1,
              name: "上",
            },
            {
              id: 2,
              name: "期",
            },
            {
              id: 3,
              name: "用",
            },
            {
              id: 4,
              name: this.downval.label,
            },
          ],
          data: data[0],
          keep: this.downval.unit,
        });
      }
      if (this.same.length) {
        if (this.same[1].data == 0 && this.same[0].data == 0) {
          this.$set(this.same, 2, {
            id: 3,
            class: [
              {
                id: 1,
                name: "同",
              },
              {
                id: 2,
                name: "比",
              },
              {
                id: 3,
                name: "率:",
              },
            ],
            data: 0,
            imggen: "",
            imgred: "",
          });
          // this.same[2].data = 0;
        } else {
          this.$set(this.same, 2, {
            id: 3,
            class: [
              {
                id: 1,
                name: "同",
              },
              {
                id: 2,
                name: "比",
              },
              {
                id: 3,
                name: "率:",
              },
            ],
            data:
              ((this.same[0].data - this.same[1].data) / this.same[1].data) *
                100 ==
              " Infinity "
                ? "100"
                : parseFloat(
                    (
                      ((this.same[0].data - this.same[1].data) /
                        this.same[1].data) *
                      100
                    ).toFixed(2)
                  ),
            imggen: require("../../assets/img/shang.png"),
            imgred: require("../../assets/img/xia.png"),
            keep: "%",
            isgrow: 0,
          });
        }

        this.$set(this.same, 3, {
          id: 4,
          class: [
            {
              id: 1,
              name: "累",
            },
            {
              id: 2,
              name: "计",
            },
            {
              id: 3,
              name: "同",
            },
            {
              id: 4,
              name: "比:",
            },
          ],
          data: this.same[2].data,
          imggen: require("../../assets/img/shang.png"),
          imgred: require("../../assets/img/xia.png"),
          keep: "%",
          isgrow: 0,
        });
        if (this.same[2].data > 0) {
          this.same[2].isgrow = 0;
        } else if (this.same[2].data < 0) {
          this.same[2].isgrow = 1;
        } else {
          this.same[2].isgrow = -1;
        }

        if (this.same[3].data > 0) {
          this.same[3].isgrow = 0;
        } else if (this.same[3].data < 0) {
          this.same[3].isgrow = 1;
        } else {
          this.same[3].isgrow = -1;
        }
      }
      this.loading = false;
    },
    async chainData() {
      this.loadingchain = true;
      this.chartRatioOption = [];
      let obj = {
        projectId: this.$store.state.project.currentProject.projectId,
        compareType: "ALTERNATE",
        date: dateFormat("YY-mm-dd", new Date()) + "T00:00:00Z",
        dateRange: this.timeval.value,
        powerType: this.downval.value.toUpperCase(),
      };
      let response = await ProjectCompareClassifiedPower(obj);
      let data = response.data.data.data[0];
      if (this.isChain == "0") {
        if (data) {
          this.$set(this.ring, 0, {
            id: 1,
            class: [
              {
                id: 1,
                name: "本",
              },
              {
                id: 2,
                name: "日",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],
            data: Number(data[1]).toFixed(2),
            keep: this.downval.unit,
          });

          this.$set(this.ring, 1, {
            id: 2,
            class: [
              {
                id: 1,
                name: "昨",
              },
              {
                id: 2,
                name: "日",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],

            data: Number(data[0]).toFixed(2),
            keep: this.downval.unit,
          });
        }
        if (this.ring.length) {
          if (this.ring[0].data == 0 && this.ring[1].data == 0) {
            // this.ring[2].data = 0;
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data: 0,
              imggen: "",
              imgred: "",
              keep: "%",
            });
          } else {
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data:
                ((this.ring[0].data - this.ring[1].data) / this.ring[1].data) *
                  100 ==
                " Infinity "
                  ? "100"
                  : parseFloat(
                      (
                        ((this.ring[0].data - this.ring[1].data) /
                          this.ring[1].data) *
                        100
                      ).toFixed(2)
                    ),
              imggen: require("../../assets/img/shang.png"),
              imgred: require("../../assets/img/xia.png"),
              keep: "%",
              isgrow: 0,
            });
          }
          this.$set(this.ring, 3, {
            id: 4,
            class: [
              {
                id: 1,
                name: "增",
              },
              {
                id: 2,
                name: "长",
              },
              {
                id: 3,
                name: "值:",
              },
            ],

            data: (this.ring[0].data - this.ring[1].data).toFixed(2),
            keep: this.downval.unit,
          });
          if (this.ring[2].data > 0) {
            this.ring[2].isgrow = 0;
          } else {
            this.ring[2].isgrow = 1;
          }
        }
        this.chartRatioOption = [
          {
            name: "本日",
            type: "bar",
            data: [Number(data[1]).toFixed(2)],
            // barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5AD8A6",
              },
            },
          },
          {
            name: "昨日",
            type: "bar",
            data: [Number(data[0]).toFixed(2)],
            // barleft: 200,
            barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5B8FF9",
              },
            },
          },
        ];
      } else if (this.isChain == "1") {
        if (data) {
          this.$set(this.ring, 0, {
            id: 1,
            class: [
              {
                id: 1,
                name: "本",
              },
              {
                id: 2,
                name: "周",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],
            data: Number(data[1]).toFixed(2),
            keep: this.downval.unit,
          });

          this.$set(this.ring, 1, {
            id: 2,
            class: [
              {
                id: 1,
                name: "上",
              },
              {
                id: 2,
                name: "周",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],

            data: Number(data[0]).toFixed(2),
            keep: this.downval.unit,
          });
        }
        if (this.ring.length) {
          if (this.ring[0].data == 0 && this.ring[1].data == 0) {
            // this.ring[2].data = 0;
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data: 0,
              imggen: "",
              imgred: "",
              keep: "%",
            });
          } else {
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data:
                ((this.ring[0].data - this.ring[1].data) / this.ring[1].data) *
                  100 ==
                " Infinity "
                  ? "100"
                  : parseFloat(
                      (
                        ((this.ring[0].data - this.ring[1].data) /
                          this.ring[1].data) *
                        100
                      ).toFixed(2)
                    ),
              imggen: require("../../assets/img/shang.png"),
              imgred: require("../../assets/img/xia.png"),
              keep: "%",
              isgrow: 0,
            });
          }
          this.$set(this.ring, 3, {
            id: 4,
            class: [
              {
                id: 1,
                name: "增",
              },
              {
                id: 2,
                name: "长",
              },
              {
                id: 3,
                name: "值:",
              },
            ],

            data: (this.ring[0].data - this.ring[1].data).toFixed(2),
            keep: this.downval.unit,
          });
          if (this.ring[2].data > 0) {
            this.ring[2].isgrow = 0;
          } else {
            this.ring[2].isgrow = 1;
          }
        }
        this.chartRatioOption = [
          {
            name: "本周",
            type: "bar",
            data: [Number(data[1]).toFixed(2)],
            // barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5AD8A6",
              },
            },
          },
          {
            name: "上周",
            type: "bar",
            data: [Number(data[0]).toFixed(2)],
            // barleft: 200,
            barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5B8FF9",
              },
            },
          },
        ];
      } else if (this.isChain == "2") {
        if (data) {
          this.$set(this.ring, 0, {
            id: 1,
            class: [
              {
                id: 1,
                name: "本",
              },
              {
                id: 2,
                name: "月",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],
            data: Number(data[1]).toFixed(2),
            keep: this.downval.unit,
          });

          this.$set(this.ring, 1, {
            id: 2,
            class: [
              {
                id: 1,
                name: "上",
              },
              {
                id: 2,
                name: "月",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],

            data: Number(data[0]).toFixed(2),
            keep: this.downval.unit,
          });
        }
        if (this.ring.length) {
          if (this.ring[0].data == 0 && this.ring[1].data == 0) {
            // this.ring[2].data = 0;
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data: 0,
              imggen: "",
              imgred: "",
              keep: "%",
            });
          } else {
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data:
                ((this.ring[0].data - this.ring[1].data) / this.ring[1].data) *
                  100 ==
                " Infinity "
                  ? "100"
                  : parseFloat(
                      (
                        ((this.ring[0].data - this.ring[1].data) /
                          this.ring[1].data) *
                        100
                      ).toFixed(2)
                    ),
              imggen: require("../../assets/img/shang.png"),
              imgred: require("../../assets/img/xia.png"),
              keep: "%",
              isgrow: 0,
            });
          }
          this.$set(this.ring, 3, {
            id: 4,
            class: [
              {
                id: 1,
                name: "增",
              },
              {
                id: 2,
                name: "长",
              },
              {
                id: 3,
                name: "值:",
              },
            ],

            data: (this.ring[0].data - this.ring[1].data).toFixed(2),
            keep: this.downval.unit,
          });
          if (this.ring[2].data > 0) {
            this.ring[2].isgrow = 0;
          } else {
            this.ring[2].isgrow = 1;
          }
        }
        this.chartRatioOption = [
          {
            name: "本月",
            type: "bar",
            data: [Number(data[1]).toFixed(2)],
            // barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5AD8A6",
              },
            },
          },
          {
            name: "上月",
            type: "bar",
            data: [Number(data[0]).toFixed(2)],
            // barleft: 200,
            barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5B8FF9",
              },
            },
          },
        ];
      } else {
        if (data) {
          this.$set(this.ring, 0, {
            id: 1,
            class: [
              {
                id: 1,
                name: "本",
              },
              {
                id: 2,
                name: "年",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],
            data: Number(data[1]).toFixed(2),
            keep: this.downval.unit,
          });
          this.$set(this.ring, 1, {
            id: 2,
            class: [
              {
                id: 1,
                name: "去",
              },
              {
                id: 2,
                name: "年",
              },
              {
                id: 3,
                name: "用",
              },
              {
                id: 4,
                name: this.downval.label,
              },
            ],
            data: Number(data[0]).toFixed(2),
            keep: this.downval.unit,
          });
        }
        if (this.ring.length) {
          if (this.ring[0].data == 0 && this.ring[1].data == 0) {
            // this.ring[2].data = 0;
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data: 0,
              imggen: "",
              imgred: "",
              keep: "%",
            });
          } else {
            this.$set(this.ring, 2, {
              id: 3,
              class: [
                {
                  id: 1,
                  name: "环",
                },
                {
                  id: 2,
                  name: "比",
                },
                {
                  id: 3,
                  name: "率:",
                },
              ],

              data:
                ((this.ring[0].data - this.ring[1].data) / this.ring[1].data) *
                  100 ==
                " Infinity "
                  ? "100"
                  : parseFloat(
                      (
                        ((this.ring[0].data - this.ring[1].data) /
                          this.ring[1].data) *
                        100
                      ).toFixed(2)
                    ),
              imggen: require("../../assets/img/shang.png"),
              imgred: require("../../assets/img/xia.png"),
              keep: "%",
              isgrow: 0,
            });
          }
          this.$set(this.ring, 3, {
            id: 4,
            class: [
              {
                id: 1,
                name: "增",
              },
              {
                id: 2,
                name: "长",
              },
              {
                id: 3,
                name: "值:",
              },
            ],

            data: (this.ring[0].data - this.ring[1].data).toFixed(2),
            keep: this.downval.unit,
          });
          if (this.ring[2].data > 0) {
            this.ring[2].isgrow = 0;
          } else {
            this.ring[2].isgrow = 1;
          }
        }
        this.chartRatioOption = [
          {
            name: "本年",
            type: "bar",
            data: [Number(data[1]).toFixed(2)],
            // barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5AD8A6",
              },
            },
          },
          {
            name: "去年",
            type: "bar",
            data: [Number(data[0]).toFixed(2)],
            // barleft: 200,
            barGap: "10%",
            barWidth: 132, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5B8FF9",
              },
            },
          },
        ];
      }

      this.loadingchain = false;
    },
  },
};
</script>

<style scoped lang="less">
.el-dropdown-menu {
  text-align: center;
}
.container {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-between;
  align-content: space-between;
  font-size: 18rem;
  .header {
    display: flex;
    justify-content: space-between;
    // padding-left: 24rem;
    // padding-right: 24rem;
    // height: 64rem;
    // line-height: 64rem;
    .title {
      font-size: 18rem;
      font-weight: 700;
      color: #333;
      span {
        font-size: 18rem;
        color: #333;
        float: left;
        cursor: pointer;
        img {
          vertical-align: middle;
          margin-left: 5px;
        }
      }
    }
    .tabs-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      span {
        height: 40rem;
        border-top: 2px solid #fff;
        font-size: 18rem;
        font-weight: 400;
        margin: 0 10rem;
        cursor: pointer;
        font-weight: bold;
      }
      .active {
        color: #0d94ff;
      }
    }
  }
  .container_one {
    width: 24vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_two {
    width: 59vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_three {
    width: 24vw;
    height: 53.5vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_four {
    width: 59vw;
    height: 53.5vh;
    justify-content: space-between;
    align-content: space-between;
    display: flex;
    flex-wrap: wrap;
  }
  .chain {
    background: #ffffff;
    padding: 20rem;
    height: 26vh;
    width: 100%;
    .cont {
      height: 20vh;
      .charts {
        height: 20vh;
        .w(800);
        float: left;
      }
    }
  }
  .energy {
    li {
      height: 40rem;
      line-height: 40rem;
      margin-top: 8rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      font-size: 18rem;
      span {
        margin-left: 45rem;
        font-weight: bold;
        font-size: 18rem;
        img {
          vertical-align: middle;
        }
      }
    }
  }
  .monthly {
    padding-left: 20rem;
    span {
      font-size: 30rem;
      color: #0d94ff;
      i {
        font-size: 18rem;
      }
    }
  }
  .used {
    padding-top: 20rem;
    padding-left: 25rem;
    float: left;
    .w(290);
    .line {
      display: flex;
      margin-bottom: 20rem;
      align-items: center;
      &:before {
        content: "";
        width: 6rem;
        height: 6rem;
        border-radius: 50%;
        background: #666;
        vertical-align: middle;
        margin-right: 10rem;
      }
      .totol {
        font-size: 21rem;
        font-weight: 400;
        color: #666;
        width: 120rem;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
        i {
          font-style: initial;
        }
      }
      .parameter {
        font-size: 16rem;
        margin-left: 8rem;
        span {
          font-size: 20rem;
          font-weight: bold;
          margin-right: 5rem;
        }
      }
    }
  }
}
</style>
